import React, { useEffect } from 'react';
import { OperationListFilterBarStyle } from './OperationListView.styles';
import { useStowageStore } from 'src/context/StowageContext';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';
import { FilterTextButton } from 'src/styles/button.style';
import OdfjellInputComponent, { InputChangeData } from 'src/components/common/odfjell-input-component/OdfjellInputComponent';

type Props = {
    selectedTab: string;
};

const OperationListFilterBarComponent: React.FC<Props> = (props) => {
    const { setActiveOperationsFilters, activeOperationsFilters } = useStowageStore();
    const { setSelectedViolationListFilter, selectedViolationListFilter, setSelectedViolationListStatusFilter, selectedViolationListStatusFilter } =
        useStowageSelectionStore();

    // =============  Use Effects ================
    useEffect(() => {
        const _activeOperationsFilters = localStorage.getItem('activeOperationsFilters');
        if (_activeOperationsFilters) {
            setActiveOperationsFilters(JSON.parse(_activeOperationsFilters));
        } else {
            setActiveOperationsFilters(['loading', 'unloading', 'transit', 'transfer']);
        }
    }, []);

    const onFilterOperationsList = (operationType: string) => {
        let _activeOperationsFilters = activeOperationsFilters;

        if (_activeOperationsFilters.find((i) => i === operationType)) {
            _activeOperationsFilters = _activeOperationsFilters.filter((i) => i !== operationType);
        } else {
            _activeOperationsFilters.push(operationType);
        }

        setActiveOperationsFilters([..._activeOperationsFilters]);

        localStorage.setItem('activeOperationsFilters', JSON.stringify(_activeOperationsFilters));
    };

    const onFilterViolationList = (filterType: string) => {
        setSelectedViolationListFilter(filterType);
    };

    const onFilterViolationStatusList = (changeObject: InputChangeData) => {
        if (changeObject.event && changeObject.event.target) {
            setSelectedViolationListStatusFilter(changeObject.event.target.value);
        }
    };

    const isOperationListFilterSelected = (filterOption: string) => {
        return activeOperationsFilters.find((x) => x === filterOption);
    };

    const isViolationListFilterSelected = (filterOption: string) => {
        return selectedViolationListFilter === filterOption;
    };

    return (
        <OperationListFilterBarStyle>
            {props.selectedTab === 'Operation List' && (
                <div className="right-wrapper">
                    <FilterTextButton
                        className={isOperationListFilterSelected('loading') ? 'selected' : ''}
                        onClick={() => onFilterOperationsList('loading')}
                    >
                        Loading
                    </FilterTextButton>
                    <FilterTextButton
                        className={isOperationListFilterSelected('unloading') ? 'selected' : ''}
                        onClick={() => onFilterOperationsList('unloading')}
                    >
                        Unloading
                    </FilterTextButton>
                    <FilterTextButton
                        className={isOperationListFilterSelected('transit') ? 'selected' : ''}
                        onClick={() => onFilterOperationsList('transit')}
                    >
                        Transit
                    </FilterTextButton>
                    <FilterTextButton
                        className={isOperationListFilterSelected('transfer') ? 'selected' : ''}
                        onClick={() => onFilterOperationsList('transfer')}
                    >
                        Transfer
                    </FilterTextButton>
                </div>
            )}
            {props.selectedTab === 'Violation List' && (
                <>
                    <div className="right-wrapper second-filter">
                        <FilterTextButton
                            className={isViolationListFilterSelected('All') ? 'selected' : ''}
                            onClick={() => onFilterViolationList('All')}
                        >
                            All violations
                        </FilterTextButton>
                        <FilterTextButton
                            className={isViolationListFilterSelected('Selected call') ? 'selected' : ''}
                            onClick={() => onFilterViolationList('Selected call')}
                        >
                            Violations for call
                        </FilterTextButton>
                    </div>
                    <div className="right-wrapper">
                        <span className="select-violation-status">
                            <OdfjellInputComponent
                                type="select"
                                options={['All statuses', 'Accepted', 'Not accepted']}
                                value={selectedViolationListStatusFilter}
                                onChange={onFilterViolationStatusList}
                                isReadOnly={false}
                            />
                        </span>
                    </div>
                </>
            )}
        </OperationListFilterBarStyle>
    );
};

export default OperationListFilterBarComponent;
